'use client';

import { Button } from '@/components/ui/Button';
import { SectionHeader } from '@/components/ui/SectionHeader';

export default function NotFound(): React.ReactNode {
  return (
    <div className=" h-[calc(100vh-20rem)] flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <SectionHeader variant="subtle" size="lg">404</SectionHeader>
        <SectionHeader variant="primary" size="xl">Page Not Found</SectionHeader>
        <p className="py-8 max-w-xl ">
            This page exists in a superposition of found and not found until observed. 
            <br/>...Unfortunately, observation collapsed it to &apos;not found&apos;.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Button href="/" variant="outline" size="sm">
            Go back home
          </Button>
          
        </div>
      </div>
    </div>
  );
} 